import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'appPercentage' })
export class PercentagePipe implements PipeTransform {
  transform(value: number, precision: number = 1): string {
    return `${(Number(value) * 100).toFixed(precision)}%`
  }
}
